export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'guide',
    name: '平台指南',
    description: '全面了解8866h.cc平台功能，快速上手使用教程与操作指引',
    icon: 'ri-compass-3-line',
    articleCount: 12,
  },
  {
    slug: 'news',
    name: '最新动态',
    description: '获取8866h.cc平台最新更新、公告及行业资讯',
    icon: 'ri-flashlight-line',
    articleCount: 8,
  },
  {
    slug: 'help',
    name: '帮助中心',
    description: '常见问题解答、故障排查及技术支持服务',
    icon: 'ri-question-line',
    articleCount: 15,
  },
];